"use client";

import { I18nData } from "@/types/i18n";
import { Branding } from "@/types/branding";
import { useLocale } from "@/context/LocaleContext";
import LanguageSwitcher from "../language-switcher/language-switcher";
import "./header.scss";

interface HeaderProps {
  i18nData?: I18nData;
  branding: Branding | null;
  slug: string;
}

export default function Header({ i18nData, branding, slug }: HeaderProps) {
  const { locale } = useLocale();
  const logoLink = branding?.logo_link ?? `/${slug}`;
  const isHomeLink = !branding?.logo_link;
  const openInNewWindow = isHomeLink
    ? false
    : branding?.open_in_new_window !== false;

  const logoTitle = isHomeLink
    ? "Link to home page"
    : (branding?.logo_tag ?? `Link to ${branding?.name} website`);

  return (
    <header
      aria-label={i18nData?.[locale]?.header_aria_label ?? "Search Tool Header"}
      role="banner"
    >
      <div id="headerBar">
        <h1
          aria-label={i18nData?.[locale]?.heading_aria_label ?? "Heading"}
          style={{ display: "none" }}
        >
          {i18nData?.[locale]?.journal_search_tool ?? "Journal Search Tool"}
        </h1>
        <a
          id="logoLink"
          title={logoTitle}
          aria-label={logoTitle}
          href={logoLink}
          target={openInNewWindow ? "_blank" : "_self"}
          rel="noopener noreferrer"
        >
          <div id="logo" />
        </a>
        <LanguageSwitcher i18nData={i18nData} />
      </div>
    </header>
  );
}
